import { useEffect } from 'react';

import { PERFORMANCE_EXTRACTION_STATUS } from 'src/data/performance';
import { captureMessage } from 'src/lib/sentry';
import { createStateSelectorHook } from 'src/lib/sweetState';
import { usePerformanceActions } from 'src/store';
import { PerformanceStore } from 'src/store/performance/PerformanceStore';

import { useChannelAccounts } from './useChannelAccounts';

const usePerformanceState = createStateSelectorHook(PerformanceStore, ['extractionStatusMap']);

export const useGetAccountLastExtraction = (channel, accountId) => {
  const performanceActions = usePerformanceActions();

  // Get current extraction status to check if account is in error state
  const { extractionStatusMap } = usePerformanceState();

  const { disconnectedAccounts } = useChannelAccounts();

  const isAccountDisconnected = disconnectedAccounts[channel]?.find(
    (account) => account.id === accountId
  );

  // Check if account is in error state to prevent endless loops
  const isAccountInErrorState =
    extractionStatusMap[channel]?.[accountId] === PERFORMANCE_EXTRACTION_STATUS.error;

  const shouldGetAccountLastExtraction =
    accountId && channel && !isAccountDisconnected && !isAccountInErrorState;

  useEffect(() => {
    if (!shouldGetAccountLastExtraction) {
      return;
    }

    performanceActions.getLastExtraction(channel, accountId).catch((error) => {
      captureMessage(`Error when getting ${channel} last extraction`, {
        level: 'warning',
        extra: {
          error: error.toString(),
          source: 'useGetAccountLastExtraction',
        },
      });
    });
  }, [shouldGetAccountLastExtraction, performanceActions, channel, accountId]);
};
